export default "__VITE_ASSET__CoqIVF_W__"